import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

export const SwiperWrapper = styled(Swiper)<{
  $desktopAspectRatio: { x: number; y: number };
  $mobileAspectRatio: { x: number; y: number };
}>`
  ${({ $desktopAspectRatio, $mobileAspectRatio, theme }) => css`
    background: transparent;

    aspect-ratio: ${$mobileAspectRatio.x} / ${$mobileAspectRatio.y};

    ${theme.media.md.up} {
      aspect-ratio: ${$desktopAspectRatio.x} / ${$desktopAspectRatio.y};
    }

    .swiper {
      &-slide {
        > * {
          width: 100%;
        }
      }

      &-pagination {
        bottom: ${theme.spacing(3)};

        &-bullet {
          border-radius: initial;
          width: 40px;
          height: 5px;
          background-color: ${theme.colors.secondaryGrey};
          opacity: 1;
          -webkit-tap-highlight-color: transparent;

          &-active {
            background-color: ${theme.colors.primary};
            height: 8px;
          }
        }
      }
    }
  `}
`;
